module.exports = __webpack_public_path__ + "img/3.2449b713.svg";